/** 
<summary>
  This functional component "UnsavedChangesPopupHOC" provides props to the child component.
  1. State "showUnsavedChangesPopup" that manages the show/hide of pop up
  2. Function "unsavedChangesToggleHandler" to toggle the show/hide popup state "showUnsavedChangesPopup"
  @developer Chandan Singh, 
  @created Date:8-May-2026 12:30 AM
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const UnsavedChangesPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showUnsavedChangesPopup, setshowUnsavedChangesPopup] =
      useState<boolean>(false);

    const unsavedChangesToggleHandler = () => {
      setshowUnsavedChangesPopup(!showUnsavedChangesPopup);
    };

    return (
      <Component
        showUnsavedChangesPopup={showUnsavedChangesPopup}
        unsavedChangesToggleHandler={unsavedChangesToggleHandler}
        {...props}
      />
    );
  };

export default UnsavedChangesPopupHOC;
